export const CUSTOM_FLAG = {
  NORMAL: 0, // 正常
  CUSTOM: 1, // 自定义
}
